import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN,
  LOGIN_USER_DATA,
  LOGIN_SUCCESS_DATA,
  LOGIN_DATA_RESET,
  LOGOUT_USER_CLEAR,
  LOGOUT_USER_SUCCESS_CLEAR,
  LOGIN_ERROR,
} from "./actionTypes"

export const loginUser = (user, history) => {
  return {
    type: LOGIN_USER,
    payload: { user, history },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = history => {
  return {
    type: LOGOUT_USER,
    payload: { history },
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const socialLogin = (type, history) => {
  return {
    type: SOCIAL_LOGIN,
    payload: { type, history },
  };
};

export const loginUserData = (user, history) => {
  return {
    type: LOGIN_USER_DATA,
    payload: { user, history },
  };
};

export const loginSuccessData = user => {
  return {
    type: LOGIN_SUCCESS_DATA,
    payload: user,
  };
};

export const loginDataReset = () => {
  return {
    type: LOGIN_DATA_RESET,
  };
};

export const logoutUserClear = history => {
  return {
    type: LOGOUT_USER_CLEAR,
    payload: { history },
  };
};

export const logoutUserSuccessClear = () => {
  return {
    type: LOGOUT_USER_SUCCESS_CLEAR,
    payload: {},
  };
};

export const loginError = error => {
  console.log("error", error);
  return {
    type: LOGIN_ERROR,
    payload: error,
  };
};
